/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */

export default [
  //404
  {
    path: '/404',
    component: () => import('@/views/404.vue'),
    meta: {
      auth: false,
    }
  },

  //503
  {
    path: '/maintenance',
    component: () => import('@/views/maintenance.vue'),
    meta: {
      auth: false,
    }
  },

  //sitemap
  {
    path: '/sitemap',
    component: () => import('@/views/sitemap.vue'),
    meta: {
      auth: false
    }
  },

  //LP
  {
    path: '/',
    component: () => import('@/views/LP/Index.vue'),
    meta: {
      auth: false,
    }
  },
  {
    path: '/en',
    component: () => import('@/views/LP/en/Index.vue'),
    meta: {
      auth: false,
    }
  },
  {
    path: '/terms-of-service',
    component: () => import('@/views/LP/terms.vue'),
    meta: {
      auth: false,
    }
  },
  {
    path: '/privacy-policy',
    component: () => import('@/views/LP/privacyPolicy.vue'),
    meta: {
      auth: false,
    }
  },
  {
    path: '/terms-of-service-en',
    component: () => import('@/views/LP/termsEn.vue'),
    meta: {
      auth: false,
    }
  },
  {
    path: '/privacy-policy-en',
    component: () => import('@/views/LP/privacyPolicyEn.vue'),
    meta: {
      auth: false,
    }
  },


  // Home
  {
    path: '/home',
    name: 'home.index',
    component: () => import('@/views/Home/Index.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // Account

  {
    path: '/account/address',
    name: 'account.address',
    component: () => import('@/views/Account/Address.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  {
    path: '/account/bank',
    name: 'account.bank',
    component: () => import('@/views/Account/Bank.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  {
    path: '/account/verification',
    name: 'account.verification',
    component: () => import('@/views/Account/Verification.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  {
    path: '/account/:name',
    name: 'account.index',
    component: () => import('@/views/Account/Index.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },


  // Login
  {
    path: '/login',
    name: 'login.index',
    component: () => import('@/views/Login/Index.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },

  // password-reset
  {
    path: '/reset-mail',
    name: 'resetMail.index',
    component: () => import('@/views/Login/resetMail.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },
  {
    path: '/reset-mail/thx',
    name: 'resetMail.thx',
    component: () => import('@/views/Login/thx.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },
  {
    path: '/password-reset/:id/:token',
    name: 'passwordReset.index',
    component: () => import('@/views/Login/passwordReset.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },
  {
    path: '/password-reset/success',
    name: 'passwordReset.success',
    component: () => import('@/views/Login/success.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },

  // Register
  {
    path: '/register',
    name: 'register.index',
    component: () => import('@/views/Register/Index.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },

  {
    path: '/register/thx',
    name: 'register.thx',
    component: () => import('@/views/Register/Thx.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },

  {
    path: '/register/activate/:token/:id',
    name: 'register.activate',
    component: () => import('@/views/Register/Activate.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },

  // Request
  { path: '/request/new',
    name: 'request.new',
    component: () => import('@/views/Request/new.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      auth: true,
    },
  },

  { path: '/request/:id',
    name: 'request.detail',
    component: () => import('@/views/Request/detail.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      auth: false,
    },
  },

  { path: '/request/edit/:id',
    name: 'request.edit',
    component: () => import('@/views/Request/edit.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      auth: true,
    },
  },

  { path: '/request/:id/success/',
    name: 'request.success',
    component: () => import('@/views/Request/success.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      auth: true,
    },
  },

  // notification
  { path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/Notification/Index.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      auth: true,
    },
  },

  { path: '/item/new',
    name: 'item.new',
    component: () => import('@/views/Item/new.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      auth: true,
    },
  },

  { path: '/item/:id',
    name: 'item.detail',
    component: () => import('@/views/Item/detail.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      auth: false,
    },
  },

  { path: '/item/edit/:id',
    name: 'item.edit',
    component: () => import('@/views/Item/edit.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      auth: true,
    },
  },

  // my-list
{ path: '/my-list',
  name: 'mylist',
  component: () => import('@/views/Mylist/Index.vue'),

  // If the user needs to be a guest to view this page.
  meta: {
    auth: true,
  },
},

  // timeline
{ path: '/timeline',
  name: 'timeline',
  component: () => import('@/views/Timeline/Index.vue'),

  // If the user needs to be a guest to view this page.
  meta: {
    auth: true,
  },
},
  //
  // {
  //   path: '/',
  //   redirect: '/home',
  // },
  //
  // {
  //   path: '/',
  //   redirect: '/home',
  // },
];
